import React from "react";
import { Faq } from "../Components/FAQ/Faq";
import { CallToActionBanner } from "../Components/CallToActionBanner";

export const FAQ = () => {
  const faqs = [
    {
      question: "What is Lorem Ipsum?",
      answer:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      question: "Why do we use it?",
      answer:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.",
    },
    {
      question: "Where does it come from?",
      answer:
        "Contrary to popular belief, Lorem Ipsum is not simply random text.",
    },
    {
      question:
        "What is the standard chunk of Lorem Ipsum used since the 1500s?",
      answer:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.",
    },
    {
      question: "Why do we use it?",
      answer:
        "Contrary to popular belief, Lorem Ipsum is not simply random text.",
    },
  ];

  return (
    <div className="px-4 max-w-3xl mx-auto text-center dark:text-white">
      <h1 className="font-[500] text-[28px] lg:pt-10">
        Frequently Asked Questions
      </h1>
      <p className="py-1 text-gray-500 text-lg dark:text-white">
        If you have any queries, we are here to provide assistance. In case you
        haven’t received a reply, you can send us an email. We will get back to
        you within 24 hours.
      </p>
      <div className="lg:pt-6 lg:pb-3">
        {faqs.map((faq) => (
          <Faq data={faq} />
        ))}
      </div>
      <CallToActionBanner
            att={"bg-black text-white dark:!bg-white dark:!text-black"}
            buttonColor={"bg-white text-black dark:!bg-black dark:!text-white"}
          />
    </div>
  );
};
